import { Phone, ClipboardList } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export function StickyCallBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 shadow-2xl md:hidden">
      <a
        href={BUSINESS.phoneHref}
        onClick={() => {
          // @ts-expect-error optional
          window.dataLayer?.push?.({ event: "phone_click", source: "sticky_bar" });
        }}
        className="flex items-center justify-center gap-2 bg-primary py-3 text-primary-foreground font-extrabold"
      >
        <Phone className="h-5 w-5" aria-hidden />
        Call Now
      </a>
      <a
        href="/#quote"
        className="flex items-center justify-center gap-2 bg-secondary py-3 text-secondary-foreground font-extrabold"
      >
        <ClipboardList className="h-5 w-5" aria-hidden />
        Free Quote
      </a>
    </div>
  );
}